module.exports = __webpack_public_path__ + "img/experienceLogo.48a9029a.png";